import { Box, FormControl, FormLabel, HStack, Text } from '@chakra-ui/react';
import { useState } from 'react';
import { useSelector } from 'react-redux';

import FieldToolTip from 'components/forms/new/FieldToolTip';
import {
    descriptionStyling,
    formLabelStyling,
    stackStyling,
} from 'components/forms/new/formStyles';

const FormFieldWithTooltip = ({
    label,
    children,
    tooltipLabel,
    fieldKey,
    helperText,
    left = '25px',
    top = '8px',
    ...tooltipProps
}) => {
    const [hoveredField, setHoveredField] = useState(null);

    const { darkMode } = useSelector((state) => state.settings);
    const isHovered = hoveredField === fieldKey;

    return (
        <FormControl
            sx={{ margin: '0 !important' }}
            onMouseEnter={() => setHoveredField(fieldKey)}
            onMouseLeave={() => setHoveredField(null)}>
            <HStack
                sx={{
                    ...stackStyling(helperText ? true : false),
                }}
                height="auto"
                spacing={4}
                align="center">
                <Box>
                    <FormLabel
                        sx={formLabelStyling(darkMode)}
                        className="!pt-0">
                        {label}
                    </FormLabel>

                    {/* Helper text positioned below the main line to avoid disrupting alignment */}
                    {helperText && (
                        <Text
                            sx={{
                                ...descriptionStyling,
                                color: darkMode ? 'gray.100' : '#757575',
                            }}
                            maxW={250}>
                            {helperText}
                        </Text>
                    )}
                </Box>

                <Box
                    flex="1"
                    display="flex"
                    maxW="520px"
                    sx={{
                        fontSize: '14px',
                    }}>
                    {children}
                    {isHovered && (
                        <FieldToolTip
                            label={tooltipLabel}
                            ariaLabel={`${fieldKey}-tip`}
                            top={top}
                            left={left}
                            {...tooltipProps}
                        />
                    )}
                </Box>
            </HStack>
        </FormControl>
    );
};

export default FormFieldWithTooltip;
